import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { unstyledAnchor } from './primitive-anchor.vanilla.mjs';

const PrimitiveAnchor = forwardRef(
  ({ disabled, href: hrefFromProps, className: classNameFromProps, ...props }, forwardedRef) => {
    const href = !disabled ? hrefFromProps : void 0;
    const role = !disabled ? "link" : void 0;
    const ariaDisabled = disabled ? true : void 0;
    const className = classNames(unstyledAnchor, classNameFromProps);
    return /* @__PURE__ */ jsx(
      StyledPrimitiveAnchor,
      {
        role,
        href,
        "aria-disabled": ariaDisabled,
        ref: forwardedRef,
        className,
        ...props
      }
    );
  }
);
const StyledPrimitiveAnchor = styled(Primitive.a);

export { PrimitiveAnchor };
//# sourceMappingURL=PrimitiveAnchor.mjs.map
